
import { Vue } from "vue-property-decorator";
import Loader from "@/components/Loader.vue";
import Multiloader from "@/components/Multiloader.vue";

export default Vue.extend({
  name: "Jaehrlichkeiten",
  components: {
    Loader,
    Multiloader
  },
  methods: {
    calcKm: function(ezg: number, hq: number): string {
      const calc = (hq * 1000) / ezg;
      return this.zahlenformaterAbflussspende(calc);
    },
    onLoadedAbfluss: function(data) {
      if (data && data.length > 0) {
        this.loadedAbfluss = true;
      }
    },
    onLoadedAbflussSpende: function(data) {
      if (data && data.length > 1) {
        this.loadedAbflussSpende = true;
      }
    },
    zahlenformater(num: number): string {
      if (num === null) {
        return "-";
      }
      if (Math.abs(num) < 1) num = +num.toFixed(3);
      else {
        const zahl = Math.abs(num);
        let result;
        if (zahl < 10) result = +zahl.toFixed(2);
        else if (zahl < 100) result = +zahl.toFixed(1);
        else if (zahl < 1000) result = +zahl.toFixed();
        else {
          const length = zahl.toString().split(".")[0].length;
          const prefix = (+zahl.toString().substring(0, 4) / 10).toFixed();
          result = +prefix * Math.pow(10, length - 3);
        }
        if (num < 0) result = 0 - result;
        num = result;
      }
      return num.toString().replace(".", ",");
    },
    zahlenformaterAbflussspende(num: number): string {
      if (num === null) {
        return "-";
      }
      const zahl = Math.abs(num);
      let result;
      if (zahl < 1000) result = +zahl.toFixed();
      else {
        const length = zahl.toString().split(".")[0].length;
        const prefix = (+zahl.toString().substring(0, 4) / 10).toFixed();
        result = +prefix * Math.pow(10, length - 3);
      }
      if (num < 0) result = 0 - result;
      num = result;

      return num.toString().replace(".", ",");
    }
  },
  data: function() {
    return {
      stammdatenView: {
        name: "messstellen_wasserstand_stammdaten",
        condition: "messstellennummer=" + this.id
      },
      jaehrlichkeiten: {
        name: "messstellen_wasserstand_jaehrlichkeiten_alljaehrlichkeiten",
        condition: "messstellennummer=" + this.id
      },
      loadedAbfluss: false,
      loadedAbflussSpende: false
    };
  },
  computed: {
    loadedData(): any {
      return this.loadedAbfluss && this.loadedAbflussSpende;
    }
  },
  props: ["id"]
});
